import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import "../Dashboard.scss";

const BoxItem = (props) => {
  const { item = {} } = props;
  return (
    <Link
      to={item.link}
      className="box-item"
      style={{ backgroundColor: item.bg_color }}
    >
      <div>
        <div className="title-box-item">{item.title}</div>
        <div className="des-box-item">{item.des}</div>
        <div
          className="icon-box-item"
          style={{ opacity: item.title === "Text Links" ? 1 : 0.2 }}
        >
          {item.icon}
        </div>
      </div>
    </Link>
  );
};

export default connect(
  (state) => ({
    profile: state.systemReducer.profile,
  }),
  {}
)(withRouter(BoxItem));
